import request from '@/util/request';
import { ALL_SUPPLIER_ID } from '@/util/constants';
export interface CompanyData {
  supplierId: string;
  supplierName: string;
  cityIds: string[];
  isAllCity: boolean;
  roles: string[];
  orgType: number;
}

interface UserInfo {
  orgs?: CompanyData[];
}

const MANUFACTURER_TYPE = 3;
/** 获取桩企列表 */
export const getCompanyList = async () => {
  const data: UserInfo = await request('/equipment-maintenance/user/userInfo', {
    method: 'GET',
  });

  /** 1. 过滤出桩企类型，去除非桩企类型（如服务商） */
  const filterManufacturer = data?.orgs?.filter(item => item.orgType === MANUFACTURER_TYPE);
  /** 2. 判断当前是否需要剔除全部桩企的选项  产品管理、运维工单需要剔除，运维不需要 */
  const noAllSupplierPath = ['/direct/product-manage', '/devops/workOrder'];
  const noAllSupplier = noAllSupplierPath.some(path => location.hash.includes(path));
  return noAllSupplier ? filterManufacturer?.filter(item => item.supplierId !== ALL_SUPPLIER_ID) : filterManufacturer;
};

interface ResourceInfo {
  permissions?: { code: string; name: string; type: number }[];
  roles?: { id: number; name: string }[];
}
/** 获取资源信息 */
export async function getResourceListBySupplierId() {
  const data: ResourceInfo = await request('/equipment-maintenance/user/resource/list', {
    method: 'GET',
  });
  return data;
}

interface QueryCompanyTypeParams {
  companyId: string;
}
interface QueryCompanyData {
  accessType?: number;
  manufactureType?: number;
}
/** 判断桩企类型 */
export const queryCompanyType = async (params: QueryCompanyTypeParams) => {
  const data: QueryCompanyData = await request('/ec-manage/platform/company/type', {
    method: 'GET',
    params,
  });
  return data;
};
